 <div class="grid-table">
        <div class="table-container shadow">
            <h1>Layouts</h1>
            <div class="table-manage">
                <div class="row">
                    <div class="col">
                        <div class="manage-item records-count">
                            <span>{{componentData.Items.length}} layouts</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="manage-item number-of-pages float-end">
                            <label>Prikaži:</label>
                            <div class="select-items">
                                <select>
                                    <option _ngcontent-gts-c7="" value="5" ng-reflect-value="5">5 zapisov / stran</option>
                                    <option _ngcontent-gts-c7="" value="10" ng-reflect-value="10">10 zapisov / stran</option>
                                    <option _ngcontent-gts-c7="" value="25" ng-reflect-value="25">25 zapisov / stran</option>
                                    <option _ngcontent-gts-c7="" value="50" ng-reflect-value="50">50 zapisov / stran</option>
                                    <option _ngcontent-gts-c7="" value="100" ng-reflect-value="100">100 zapisov / stran</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-wrapper">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Master page</th>
                            <th>Http alias</th>
                            <th>Root url</th>
                            <th class="actions"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of componentData.Items">
                            <td>{{item.Name}}</td>
                            <td>{{item.LayoutName}}</td>
                            <td>{{item.HttpAlias}}</td>
                            <td>{{item.RootUrl}}</td>
                            <td>
                                <div class="controls">
                                    <div class="edit"><a routerLink="/edit/"></a></div>
                                    <div class="settings"><a></a></div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>